// extracted by mini-css-extract-plugin
export default {"footer":"StickyButtons_footer__rq6Nq","actions":"StickyButtons_actions__h5Pk8","wrapper":"StickyButtons_wrapper__-kNxv","helptext":"StickyButtons_helptext__HiAaF"};